import Button from "@mui/material/Button";
import {_transl} from "../../store/localization/TranslMessasge";
import {CommonTranslation} from "../../pages/main/content/CommonTranslation";
import React from "react";
import {ButtonPropTypes} from "./ButtonPropTypes";

interface DeleteButtonProps {
    onClick: (event?: any) => void,
    variant?: ButtonPropTypes.Variant,
    size?: ButtonPropTypes.Size;
}

export function DeleteButton(props: DeleteButtonProps) {

    const {onClick, variant, size} = props;

    return (
        <Button onClick={onClick}
                variant={variant ?? "contained"}
                color={"error"}
                size={size} >
            {_transl(CommonTranslation.REMOVE)}
        </Button>
    )
}

